module.exports = __webpack_public_path__ + "img/mob-buy-bg.9ef8d3c4.png";